<div class="jolojo-ui__icon"
  style:font-size={`var(--jolojo-ui-${size}-font-size)`}
  style:color={colour}
  class:clickable={$$slots.click}
  style:font-weight={fontWeight}
>
  {icon}
</div>

<script>
  export let icon = ''
  export let colour = 'black'
  export let size = 'lg'
  export let fontWeight = 'normal'
</script>

<style>
  .jolojo-ui__icon {
    font-family: 'Material Icons';
    background: none;
    border: none;
    padding: 0;
  }

  .clickable {
    cursor: pointer;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>